import React, { lazy, Suspense } from "react";

/**
 * 懒加载方法
 * 由于props在组件中传递，会死循环，
 * 所以当props为true时，仅返回懒加载的组件。
 * @param  loader   需要懒加载的组件
 * @param  fallback 在加载组件时的内容展示
 * @param  props    需要传递给组件的参数
 */
export default (loader: any, fallback: string | JSX.Element = "", props?: any) => {
  const OtherComponent = lazy(loader);
  return props === true
  ? OtherComponent
  : () => 
      <Suspense fallback={fallback}>
        <OtherComponent {...props} />
      </Suspense>
}
